/* eslint-disable no-unused-vars */
function printInlay(inlay) {
  let printEl = document.getElementById("print");
  let content = "";
  let group = inlay.group;
  if (!inlay.name.includes("gt6l")) {
    if (inlay.name.includes("gt10")) {
      content += makeContent(convertMeasurements(inlay.inlay), group);
      revertMeasurements(inlay.inlay);
    } else {
      content += makeContent(inlay.inlay, group);
    }
  } else {
    let btn_index = 0,
      led_idx = 0;

    inlay.inlay.forEach((single_inlay, index) => {
      // single_inlay.style.left = inlay.preview.btns[index].style.left;
      for (let btn in single_inlay.btns) {
        // single_inlay.btns[btn].style.left =
        //   inlay.preview.btns[btn_index].style.left;
        btn_index++;
      }
      for (let led in single_inlay.leds) {
        single_inlay.leds[led].style.left =
          inlay.preview.leds[led_idx].style.left;
        led_idx++;
      }
      content += makeContent(single_inlay, group);
    });
  }
  //console.log(content);
  printEl.innerHTML += content;
}

//TODO: rework
function convertMeasurements(inlay) {
  let reduction = 85;

  inlay.style.top =
    parseFloat(inlay.style.top.substring(0, inlay.style.top.length - 2)) -
    reduction +
    "mm";
  for (let button in inlay.btns) {
    let oldVal = parseFloat(
      inlay.btns[button].style.top.substring(
        0,
        inlay.btns[button].style.top.length - 2
      )
    );
    let newVal = oldVal - reduction;
    inlay.btns[button].style.top = newVal + "mm";
  }
  for (let led in inlay.leds) {
    let oldVal = parseFloat(
      inlay.leds[led].style.top.substring(
        0,
        inlay.leds[led].style.top.length - 2
      )
    );
    let newVal = oldVal - reduction;
    inlay.leds[led].style.top = newVal + "mm";
  }
  return inlay;
}
function revertMeasurements(inlay) {
  let reduction = 85;
  inlay.style.top =
    parseFloat(inlay.style.top.substring(0, inlay.style.top.length - 2)) +
    reduction +
    "mm";
  for (let button in inlay.btns) {
    let oldVal = parseFloat(
      inlay.btns[button].style.top.substring(
        0,
        inlay.btns[button].style.top.length - 2
      )
    );
    let newVal = oldVal + reduction;
    inlay.btns[button].style.top = newVal + "mm";
  }
  for (let led in inlay.leds) {
    let oldVal = parseFloat(
      inlay.leds[led].style.top.substring(
        0,
        inlay.leds[led].style.top.length - 2
      )
    );
    let newVal = oldVal + reduction;
    inlay.leds[led].style.top = newVal + "mm";
  }
}
function draggableLeft(value, correction) {
  let oldValue = parseInt(value.substring(0, value.length - 2));
  let newValue = oldValue - correction;
  return newValue;
}

function makeContent(selected_inlay, group) {
  let content = '<div style="position:relative;margin:5px; float:left;';
  content += selected_inlay.style.horizontal ? "margin-left:50px;" : "";

  content += '" class="' + group + '">';
  if (group == "gt6l")
    content =
      '<div style="position:relative;min-width:200px;margin:15px; min-height:200px;float:left;" class="' +
      group +
      '">';
  content +=
    '<div class="inlay ' + group + '" style="background-repeat:no-repeat;';

  Object.keys(selected_inlay.style).forEach((key) => {
    // if (inlay.name.includes("gt10") && key.includes("top")) {
    //   content += "top:5mm;";
    // } else {
    //   content += key + ":" + selected_inlay.style[key] + ";";
    // }
    content += key + ":" + selected_inlay.style[key] + ";";
  });

  content +=
    '"><div class="gt8BlackTriangles" style="width: 100%; height: 100%"></div>';
  content += !selected_inlay.style.horizontal
    ? '<div class="cutline"></div><p class="cuttext">Schnittlinie nur für GTS-Serie</p>'
    : "";
  for (let draggable in selected_inlay.draggableTexts) {
    content += '<p style="z-index:100;position:absolute;top:';
    if (!selected_inlay.style.horizontal) {
      if (group.includes("gt6l")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 52.9) +
          "px";
      } else if (group.includes("mt4")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 71.8) +
          "px";
      } else if (group.includes("gt2t")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 41.5) +
          "px";
      } else if (group.includes("gt8")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, -5.7) +
          "px";
      } else if (group.includes("gt12")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 4.9) +
          "px";
      } else if (group.includes("gt10")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 321.26) +
          "px";
      } else {
        content += selected_inlay.draggableTexts[draggable].top;
      }
    } else {
      if (group.includes("gt6l")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 35) +
          "px";
      } else if (group.includes("gt12")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 54.5) +
          "px";
      } else if (group.includes("gt2t")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].top, 102.9) +
          "px";
      }
    }

    content += ";left:";
    if (!selected_inlay.style.horizontal) {
      if (group.includes("gt6l")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 37.8) +
          "px";
      } else if (group.includes("mt4")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 71.8) +
          "px";
      } else {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 52.3) +
          "px";
      }
    } else {
      if (group.includes("gt6l")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 50) +
          "px";
      } else if (group.includes("gt12")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 7) +
          "px";
      } else if (group.includes("gt2t")) {
        content +=
          draggableLeft(selected_inlay.draggableTexts[draggable].left, 50) +
          "px";
      }
    }

    content += ";";
    Object.keys(selected_inlay.draggableTexts[draggable].style).forEach(
      (key) => {
        content +=
          key + ":" + selected_inlay.draggableTexts[draggable].style[key] + ";";
      }
    );
    content += '">' + selected_inlay.draggableTexts[draggable].content + "</p>";
  }
  content += "</div>";

  for (let btn in selected_inlay.btns) {
    content += '<div class="gt-btn" style="position:absolute;';

    Object.keys(selected_inlay.btns[btn].style).forEach((key) => {
      if (key !== "content" && key !== "image")
        content += key + ":" + selected_inlay.btns[btn].style[key] + ";";
    });
    content += '">';

    content +=
      '<div class="gt-btn-img" style="background-position:' +
      selected_inlay.btns[btn].style.image["background-position"] +
      ";height: " +
      selected_inlay.btns[btn].style["height"] +
      ";width: " +
      selected_inlay.btns[btn].style["width"] +
      ";background-image: " +
      selected_inlay.btns[btn].style.image["background-image"] +
      ";filter: " +
      selected_inlay.btns[btn].style.image["filter"] +
      ";background-size: " +
      selected_inlay.btns[btn].style.image["background-size"] +
      ';"></div>';

    content +=
      '<div class=" d-flex gt-btn-container ' +
      selected_inlay.btns[btn].content.style["justify-content"] +
      " " +
      selected_inlay.btns[btn].content.style["align-items"] +
      '"><p style="';
    Object.keys(selected_inlay.btns[btn].content.style).forEach((key) => {
      if (key !== "content")
        content +=
          key + ":" + selected_inlay.btns[btn].content.style[key] + ";";
    });
    if (!selected_inlay.btns[btn].content["d-content"])
      content += "display:none;";
    content +=
      '" class="btn_text">' +
      selected_inlay.btns[btn].content.content +
      "</p></div></div>";
  }
  for (let led in selected_inlay.leds) {
    content += '<div class="led" style="border:1px dashed grey;';
    Object.keys(selected_inlay.leds[led].style).forEach((key) => {
      content += key + ":" + selected_inlay.leds[led].style[key] + ";";
    });

    content += '"></div>';
  }
  for (let barGLed in selected_inlay.bargraph) {
    content += '<div class="bar_g" style="';
    Object.keys(selected_inlay.bargraph[barGLed].style).forEach((key) => {
      content += key + ":" + selected_inlay.bargraph[barGLed].style[key] + ";";
    });
    content +=
      "display:" +
      (selected_inlay.showBargraph &&
      selected_inlay.selectedBarGType == selected_inlay.bargraph[barGLed].type
        ? "block;"
        : "none;");
    content +=
      '" id="' +
      selected_inlay.bargraph[barGLed].type +
      "_" +
      selected_inlay.bargraph[barGLed].id +
      '"></div>';
    //   //now add the captions
    content += '<div class="bar_g_caption" style="';
    Object.keys(selected_inlay.bargraph[barGLed].caption.style).forEach(
      (key) => {
        content +=
          key + ":" + selected_inlay.bargraph[barGLed].caption.style[key] + ";";
      }
    );
    selected_inlay.showBargraphCaptions &&
    selected_inlay.selectedBarGType == selected_inlay.bargraph[barGLed].type
      ? (content += "display:block;")
      : (content += "display:none;");
    content += '" id="' + selected_inlay.bargraph[barGLed].id;
    content +=
      '">' + selected_inlay.bargraph[barGLed].caption.content + "</div>";
  }
  // newEl.innerHTML = content;
  // printEl.append(newEl);
  content += "</div>";
  // console.log(content);
  return content;
}

function print() {
  window.print();
  let printEl = document.getElementById("print");

  printEl.innerHTML = "";
}

export { print, printInlay };
